<template>
    <div 
        class="pointer"
        style="font-size: 20px; position: relative;"
        @click="openPicker"
    >
        <i class="fa fa-eyedropper" />&nbsp;
        <span
            class="color-block" 
            :class="{'color-block-transparent': color === 'transparent'}"
            :style="{backgroundColor: pickedColor}" 
        />
        <div
            class="dropdown-menu color-menu" 
            style="position: absolute;"
            :class="{show: pickerActive}"
            :style="{'top': top ? 'auto' : '0', 'bottom': top ? '30px' : 'auto'}"
        >
            <span
                v-for="paletteColor in palette"
                :key="paletteColor"
                class="dropdown-item pointer"
                @click.stop="setColor(paletteColor)"
            >
                <span
                    v-if="color == paletteColor"
                    class="fa fa-caret-right"
                    style="width: 10px;"
                />
                <span
                    v-else
                    class="fa"
                    style="width: 10px;"
                />
                <div
                    class="color-block"
                    :class="{'color-block-transparent': paletteColor === 'transparent'}"
                    :style="{backgroundColor: paletteColor}"
                />
                {{ paletteColor === 'transparent' ? 'прозрачный' : paletteColor }}
            </span>
            <hr
                v-if="usercolors"
                style="margin: 5px;"
            >
            <span
                v-if="usercolors"
                class="dropdown-item pointer"
            >
                <span
                    v-if="!palette.includes(color)"
                    class="fa fa-caret-right"
                    style="width: 10px;" 
                />
                <span
                    v-else
                    class="fa"
                    style="width: 10px;" 
                />
                <label
                    :for="'color-input'+_uid"
                    style="width: 100%;"
                    class="pointer"
                >
                        <div
                            v-if="!palette.includes(color)"
                            class="color-block"
                            :style="{backgroundColor: color}"
                        />
                        <span
                            v-else
                            class="fa fa-eyedropper"
                            style="width: 20px;"
                        />
                        другой
                    <input
                        :id="'color-input'+_uid"
                        v-model="pickedColor"
                        style="width: 0px; height: 0px; visibility: hidden; padding: 0; overflow: hidden;"
                        type="color"
                        @change="closePicker"
                    >
                </label>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ColorPicker',
        props: {
            'color': { 
                'type': String,
                'default': '#000000'
            },
            'palette': {
                'type': Array,
                'default': [] 
            },
            'usercolors': {
                'type': Boolean,
                'default': false,
            },
            top: {
                'type': Boolean,
                'default': false,
            }
        },
        data: function() {
            return {
                pickedColor: this.color,
                pickerActive: false,
            }
        },
        watch: { 
            pickedColor: function(val) {
                this.$emit('change', val);
            },
        },
        methods: {
            openPicker: function() {
                if (this.pickerActive) return;
                this.pickerActive = true;
                document.addEventListener('click', this.closePicker, true);
            },
            closePicker: function() {
                if (!this.pickerActive) return;
                this.pickerActive = false;
                document.removeEventListener('click', this.closePicker, true);
            },
            setColor: function(color) {
                this.pickedColor = color;
                this.pickerActive = false;
            },
        }
    }
</script>


